import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, SERVICES } from '../../services/api';
import apiAsyncThunkCreator from '../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../rootReducer';
import { IHubspotAccount } from './account';

export interface IFetchHubspotAccountsRequest {
  available?: boolean;
}

export const fetchHubspotAccounts: AsyncThunk<
  { accounts: IHubspotAccount[] },
  IFetchHubspotAccountsRequest,
  ThunkAPI
> = createAsyncThunk(
  'accounts/fetchHubspotAccounts',
  (request, thunk) => {
    const queryParams = Object.entries(request).map(([key, value]) => `${key}=${value}`).join('&');

    return apiAsyncThunkCreator<{ accounts: IHubspotAccount[] }, void>({
      endpoint: `accounts/${queryParams ? '?' + queryParams : ''}`,
      microservice: SERVICES.HUBSPOT_SERVICE,
      authenticated: true,
      method: HttpMethods.Get
    })(undefined, thunk);
  }
);

export const fetchHubspotAccountById: AsyncThunk<
  { account: IHubspotAccount },
  string,
  ThunkAPI
> = createAsyncThunk(
  'accounts/fetchHubspotAccountById',
  (accountId: string, thunk) => {
    return apiAsyncThunkCreator<{ account: IHubspotAccount }, void>({
      endpoint: `accounts/${accountId}`,
      microservice: SERVICES.HUBSPOT_SERVICE,
      authenticated: true,
      method: HttpMethods.Get
    })(undefined, thunk);
  }
);